import { Box, Button, Flex } from 'styling/GlobalStyles'
import { BedStatusChip, Container, ContainerContent, ContainerHeader, HeaderButton, IconContainer, PersonChip, SelectedEmployeeImage, StepNumber } from '../Accommodation.style'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { useCallback, useEffect, useState } from 'react'
import { NextIcon } from '../icons/NextIcon'
import { Input } from 'components/Input/Input'
import { WhitePersonIcon } from '../icons/WhitePersonIcon'
import Avatar from '../../../assets/images/profileAvatar.png'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { ConfirmCheckInModal } from '../ConfirmCheckInModal'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { clearBeds, getBeds } from 'features/accommodation/accommodationSlice'
import { IGetAllAvailableBedsSingleResponse } from 'types/api/accommodationApi.interface'
import { bedStatesOptions } from './AddAccommodationModal'
import { toast } from 'react-toastify'
import { formatDateForDisplay, getDateDifference } from 'utils/helpers'

const SelectBedGuest = ({ guest }: { guest: IGuest }) => {

    const dispatch = useDispatch<AppDispatch>()

    useEffect(() => {
        dispatch(getBeds({ page: 1, limit: 99, tierPolicy: guest.tierPolicy?.value, genderPolicy: guest.gender?.value }))
    }, [guest])

    return <Box>
        <Flex gap='1rem' >
            <SelectedEmployeeImage>
                <img
                    src={Avatar}
                    alt='profile-image'
                    onError={({ currentTarget }) => (currentTarget.src = Avatar)}
                />
            </SelectedEmployeeImage>
            <Flex column width='100%' gap='0.5rem' >
                <Flex width='100%' >
                    <OtherText color='#ff9900' >SELECTED PERSON</OtherText>
                </Flex>
                <TitleText>{guest?.firstName} {guest?.lastName}</TitleText>
            </Flex>
        </Flex>
        <Flex mt='16' mb='16' center gap='0.5rem' ><PersonChip type='Guest'>Guest</PersonChip>  <OtherText grey >ID: {guest?.id}</OtherText></Flex>
        <Flex column gap='1rem' mt='48' >
            <Flex width='100%' gap='1rem' >
                <Box width='100%'>
                    <Flex column gap='0.5rem' >
                        <OtherText grey>GENDER</OtherText>
                        <TitleText>{guest?.gender?.label}</TitleText>
                    </Flex>
                </Box>
                <Box width='100%' >
                    <Flex column gap='0.5rem' >
                        <OtherText grey>TIER</OtherText>
                        <TitleText>{guest?.tierPolicy?.label}</TitleText>
                    </Flex>
                </Box>
            </Flex>
            <Flex width='100%' gap='1rem' >
                <Box width='100%'>
                    <Flex column gap='0.5rem' >
                        <OtherText grey>Check-In</OtherText>
                        <TitleText>{formatDateForDisplay(guest?.checkIn)}</TitleText>
                    </Flex>
                </Box>
                <Box width='100%' >
                    <Flex column gap='0.5rem' >
                        <OtherText grey>Check-Out</OtherText>
                        <TitleText>{formatDateForDisplay(guest?.checkOut)}</TitleText>
                    </Flex>
                </Box>
            </Flex>
        </Flex>
        <Flex mt='32' between width='100%' >
            <BodyText grey >Total Stay Duration</BodyText>
            <BodyText  >{getDateDifference(guest?.checkIn, guest?.checkOut)}</BodyText>
        </Flex>
    </Box>
}


const SelectStayAndDuration = ({ type, selectedEmployee, setSelectedEmployee, guest }) => {
    return <Container >
        <ContainerContent noHeader gap='1rem'>
            {type == 'Employee' ? <SelectBedEmployee selectedEmployee={selectedEmployee} setSelectedEmployee={setSelectedEmployee} /> : <SelectBedGuest guest={guest} />}
        </ContainerContent>
    </Container>
}

const SelectBedEmployee = ({ setSelectedEmployee, selectedEmployee }: { setSelectedEmployee: React.Dispatch<React.SetStateAction<ISelectedEmployee>>, selectedEmployee: ISelectedEmployee }) => {
    const dispatch = useDispatch<AppDispatch>()

    useEffect(() => {
        dispatch(getBeds({ page: 1, limit: 99, tierPolicy: selectedEmployee.tierPolicy, genderPolicy: selectedEmployee.gender == 'm' ? 1 : 2, checkInTimestamp: selectedEmployee.checkIn.toISOString(), expectedCheckOutTimestamp: selectedEmployee.checkOut.toISOString() }))
    }, [selectedEmployee])

    return <>
        <Box>
            <Flex gap='1rem' >
                <SelectedEmployeeImage>
                    <img
                        src={selectedEmployee?.profileImageUrl || Avatar}
                        alt='profile-image'
                        onError={({ currentTarget }) => (currentTarget.src = Avatar)}
                    />
                </SelectedEmployeeImage>
                <Flex column width='100%' gap='0.5rem' >
                    <Flex width='100%' >
                        <OtherText color='#ff9900' >SELECTED PERSON</OtherText>
                    </Flex>
                    <TitleText>{selectedEmployee?.label}</TitleText>
                </Flex>
            </Flex>
            <Flex mt='16' mb='16' center gap='0.5rem' ><PersonChip type='Employee'>Employee</PersonChip>  <OtherText grey >ID: {selectedEmployee?.id || '/'}</OtherText></Flex>
            <Flex width='100%' gap='1rem' >
                <Box width='100%'>
                    <Flex column gap='0.5rem' >
                        <OtherText grey>Role</OtherText>
                        <TitleText>{selectedEmployee?.role || '/'}</TitleText>
                    </Flex>
                </Box>


                {/* <Box width='100%' >
                        <Flex column gap='0.5rem' >
                            <OtherText grey>TIER</OtherText>
                            <TitleText>Standard</TitleText>
                        </Flex>
                    </Box>*/}
            </Flex>
        </Box>
        <Box>
            <Flex column gap='0.5rem'>
                <TitleText style={{ marginBottom: '1rem' }}>Stay Duration</TitleText>
                <Flex mt='32' between width='100%' >
                    <BodyText grey >Total Stay Duration</BodyText>
                    <BodyText  >{getDateDifference(selectedEmployee?.checkIn, selectedEmployee?.checkOut)}</BodyText>
                </Flex>
                <Flex width='100%' gap='1rem' >
                    <Box width='100%'>
                        <Flex column gap='0.5rem' >
                            <OtherText grey>Check In</OtherText>
                            <TitleText>{formatDateForDisplay(selectedEmployee?.checkIn)}</TitleText>
                        </Flex>
                    </Box>
                    <Box width='100%'>
                        <Flex column gap='0.5rem' >
                            <OtherText grey>Check Out</OtherText>
                            <TitleText>{formatDateForDisplay(selectedEmployee?.checkOut)}</TitleText>
                        </Flex>
                    </Box>
                </Flex>
            </Flex>

        </Box>
    </>
}

const EmployeeSelect = ({ setSelectedEmployee, selectedEmployee, setStep }: { setSelectedEmployee: React.Dispatch<React.SetStateAction<ISelectedEmployee>>, selectedEmployee: ISelectedEmployee, setStep: React.Dispatch<React.SetStateAction<1 | 2>> }) => {
    const Option = () => {
        return <Box style={{ cursor: 'pointer' }} >
            <Flex column gap='0.5rem' >
                <TitleText>John Smith</TitleText>
                <BodyText grey>Male • Standard</BodyText>
            </Flex>
        </Box>
    }

    const handleDate = (date: Date, name: string) => {
        setSelectedEmployee(prev => ({ ...prev, [name]: date }))
    }
    return <>
        <TitleText style={{ fontSize: 18 }} >Search Employee</TitleText>
        <BodyText grey>Search from HRDL system</BodyText>

        <HonestSelectAsyncInput
            nomarg
            link='users/basic'
            name='employee'
            onChange={(v) => setSelectedEmployee({ ...v })}
            defaultValue={selectedEmployee?.label}
            parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.fullName, profilePictureUrl: i.getImagePresignedUrl, value: i.id, id: i.accessCardId, role: i.role, gender: i.gender, tierPolicy: i.currentContract?.logisticsInfo?.accomodationTierPolicy }))}
        />

        <Box>
            <Flex column gap='0.5rem'>
                <TitleText style={{ marginBottom: '1rem' }}>Stay Duration</TitleText>
                <CalendarInput defaultValue={selectedEmployee?.checkIn} onChange={date => handleDate(date, 'checkIn')} minDate={new Date()} labelText='Check-In' nomarg />
                <CalendarInput defaultValue={selectedEmployee?.checkOut} onChange={date => handleDate(date, 'checkOut')} minDate={selectedEmployee?.checkIn} labelText='Check-Out' nomarg />
                <Flex mt='32' between width='100%' >
                    <BodyText grey >Total Stay Duration</BodyText>
                    <BodyText  >{getDateDifference(selectedEmployee?.checkIn, selectedEmployee?.checkOut)}</BodyText>
                </Flex>
            </Flex>
        </Box>

        <Button orange mt='16' disabled={!selectedEmployee?.value || !selectedEmployee?.checkIn || !selectedEmployee?.checkOut} onClick={() => setStep(2)} width='100%' >Save</Button>
        {/* <OtherText grey style={{ margin: '1rem 0' }} >QUICK SELECT</OtherText>
        <Option />
        <Option />
        <Option /> */}
    </>
}


const SelectPerson = ({ setType, type, setGuest, guest, setSelectedEmployee, selectedEmployee, setStep }: { setType: React.Dispatch<React.SetStateAction<string>>, type: string, setGuest: React.Dispatch<React.SetStateAction<IGuest>>, guest: IGuest, setSelectedEmployee: React.Dispatch<React.SetStateAction<ISelectedEmployee>>, selectedEmployee: ISelectedEmployee, setStep: React.Dispatch<React.SetStateAction<1 | 2>> }) => {
    return <Container>
        <ContainerHeader>
            <HeaderButton active={type === 'Employee'} onClick={() => setType('Employee')} >Employee</HeaderButton>
            <HeaderButton active={type === 'Guest'} onClick={() => setType('Guest')} >Guest</HeaderButton>
        </ContainerHeader>
        <ContainerContent style={{ gap: '0.5rem' }} >
            {type == 'Employee' ? <EmployeeSelect setSelectedEmployee={setSelectedEmployee} selectedEmployee={selectedEmployee} setStep={setStep} /> : <GuestSelect setGuest={setGuest} setStep={setStep} guest={guest} />}
        </ContainerContent>
    </Container>
}

const GuestSelect = ({ guest, setGuest, setStep }: { guest: IGuest, setGuest: React.Dispatch<React.SetStateAction<IGuest>>, setStep: React.Dispatch<React.SetStateAction<1 | 2>> }) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value, name } = e.target
        setGuest(prev => ({ ...prev, [name]: value }))
    }

    const handleSelect = (v: ISelectValue, name: string) => {
        setGuest(prev => ({ ...prev, [name]: v }))
    }

    const handleDate = (date: Date, name: string) => {
        setGuest(prev => ({ ...prev, [name]: date }))
    }

    const checkDisabled = useCallback(() => {

        return (!guest.firstName || !guest.lastName || !guest.gender?.value || !guest.tierPolicy?.value || !guest.checkIn || !guest.checkOut)

    }, [guest])

    return <>
        <TitleText style={{ fontSize: 18 }} >Guest Registration</TitleText>
        <BodyText grey>Manual entry for non-employee guests</BodyText>
        <Flex column gap='1rem' >
            <Flex width='100%' gap='1rem' >
                <Input onChange={handleChange} value={guest.firstName} name='firstName' labelText='First Name' nomarg placeholder='Enter here...' />
                <Input onChange={handleChange} value={guest.lastName} name='lastName' labelText='Last Name' nomarg placeholder='Enter here...' />
            </Flex>
            <Flex width='100%' gap='1rem' >
                <HonestSelectInput options={genderOptions} labelText='Gender' defaultValue={guest?.gender?.value} name='gender' onChange={handleSelect} nomarg />
                <HonestSelectInput onChange={handleSelect} options={tierOptions} defaultValue={guest?.tierPolicy?.value} labelText='Tier' name='tierPolicy' nomarg />
            </Flex>
            <Input onChange={handleChange} value={guest.identificationNumber} name='identificationNumber' labelText='Identification Number' nomarg placeholder='Enter here...' />
            <CalendarInput minDate={new Date()} defaultValue={guest.checkIn} onChange={date => handleDate(date, 'checkIn')} labelText='Check-In' nomarg />
            <CalendarInput minDate={guest.checkIn} defaultValue={guest.checkOut} onChange={date => handleDate(date, 'checkOut')} labelText='Check-Out' nomarg />
            <Button orange disabled={checkDisabled()} width='100%' mt='16' onClick={() => setStep(2)} >Continue With Guest</Button>
        </Flex>

    </>
}

export const CheckIn = () => {
    const [step, setStep] = useState<1 | 2>(1)
    const [type, setType] = useState('Employee')
    const [modal, setModal] = useState({ open: false, value: null })
    const { beds } = useSelector((state: RootState) => state.accomodation)
    const [selectedEmployee, setSelectedEmployee] = useState<ISelectedEmployee>({
        label: '',
        value: null,
        role: null,
        gender: null,
        id: null,
        checkIn: null,
        checkOut: null,
        tierPolicy: null,
        profileImageUrl: ''
    })
    const [guest, setGuest] = useState<IGuest>({
        firstName: '',
        lastName: '',
        gender: null,
        tierPolicy: null,
        checkIn: null,
        identificationNumber: null,
        checkOut: null,
    })

    const Step = ({ step, name, active, onClick, pointer }: { step: number, name: string, active: boolean, onClick?: () => void, pointer?: boolean }) => {
        return <Flex center gap='1rem' onClick={onClick} style={{ cursor: pointer ? 'pointer' : 'default' }} >
            <StepNumber active={active} >  {step}</StepNumber>
            <BodyText grey={!active} >{name}</BodyText>
        </Flex>
    }



    const NoPersonSelected = () => {
        return <Flex center justcenter height='100%' column gap='1rem' >
            <IconContainer>
                <WhitePersonIcon />
            </IconContainer>
            <TitleText>No person selected</TitleText>
            <BodyText grey>Select a person to view available beds and fill all required data</BodyText>
        </Flex>
    }

    const NoAvailableBebds = () => {
        return <Flex center justcenter height='100%' column gap='1rem' >
            <IconContainer>
                <WhitePersonIcon />
            </IconContainer>
            <TitleText>No Beds Available</TitleText>
            <BodyText grey>{'There are no beds available for selected person\'s tier and gender'} </BodyText>
        </Flex>
    }

    const Bed = ({ bed }: { bed: IGetAllAvailableBedsSingleResponse }) => {

        const handleClick = () => {
            if (type === 'Employee' && (!selectedEmployee.checkIn || !selectedEmployee.checkOut)) {
                toast.warn('Please select check-in and check-out dates')
                return
            } else if (type === 'Guest' && (!guest.checkIn || !guest.checkOut || !guest.firstName || !guest.lastName || !guest.gender || !guest.tierPolicy?.value)) {
                toast.warn('Please fill all required fields')
                return
            }
            setModal({
                open: true, value: {
                    person: type === 'Employee' ? selectedEmployee.label || 'John Smith' : guest.firstName + ' ' + guest.lastName,
                    type: type,
                    checkIn: selectedEmployee.checkIn || guest.checkIn || '',
                    checkOut: selectedEmployee.checkOut || guest.checkOut || '',
                    bed: bed.label,
                    bedId: bed.id,
                    userId: type === 'Employee' ? selectedEmployee.value : null,
                    gender: type === 'Employee' ? selectedEmployee.gender : guest.gender,
                    identificationNumber: type === 'Guest' ? guest.identificationNumber : null,
                    location: `${bed.roomName} · ${bed.blockName} · ${bed.campName}`
                }
            })
        }

        return <Box width='100%' style={{ cursor: 'pointer' }} onClick={handleClick} >
            <Flex column gap='1rem' >
                <Flex between width='100%' >
                    <Flex><TitleText>{bed.label}</TitleText></Flex>
                    <BedStatusChip status={bedStatesOptions.find(s => s.value === bed.bedState)?.label || 'Available'}>{bedStatesOptions.find(s => s.value === bed.bedState)?.label || 'Available'}</BedStatusChip>
                </Flex>
                <BodyText grey >{bed.blockGenderPolicy} · {bed.blockTierPolicy}</BodyText>
                <Flex gap='0.5rem' >
                    <BodyText grey > {bed.campName}</BodyText>
                    <NextIcon />
                    <BodyText grey > {bed.blockName}</BodyText>
                    <NextIcon />
                    <BodyText grey > {bed.roomName} </BodyText>
                </Flex>
            </Flex>

        </Box>
    }

    const dispatch = useDispatch<AppDispatch>()

    const closeModal = (saved?: boolean) => {
        if (saved) {
            setSelectedEmployee({
                label: '',
                value: null,
                role: null,
                gender: null,
                id: null,
                checkIn: null,
                checkOut: null,
                tierPolicy: null,
                profileImageUrl: ''
            })
            setGuest({
                firstName: '',
                lastName: '',
                gender: null,
                tierPolicy: null,
                checkIn: null,
                checkOut: null,
                identificationNumber: null,
            })
            setStep(1)
            dispatch(clearBeds())
        }

        setModal({ open: false, value: null })
    }

    return <>
        <Flex mt='32' mb='16' width='100%' between >
            <Flex gap='1rem' center>
                <Step pointer step={1} name='Select Person' active={step === 1} onClick={() => setStep(1)} />
                <NextIcon />
                <Step step={2} name='Select Stay Duration and Bed' active={step === 2} />
                {/* <NextIcon />
                <Step step={3} name='Confirm' active={step === 3} /> */}
            </Flex>
        </Flex>
        <Flex width='100%' between gap='1rem'>
            {step == 1 ? <SelectPerson selectedEmployee={selectedEmployee} setGuest={setGuest} guest={guest} setSelectedEmployee={setSelectedEmployee} setStep={setStep} setType={setType} type={type} /> :
                <SelectStayAndDuration guest={guest} type={type} selectedEmployee={selectedEmployee} setSelectedEmployee={setSelectedEmployee} />}
            <Container style={{ maxHeight: '530px', display: 'flex', flexDirection: 'column' }}>
                <ContainerHeader><TitleText style={{ lineHeight: '50px', marginLeft: '1rem' }} >Select Bed</TitleText></ContainerHeader>
                <ContainerContent gap='1rem' style={{ flex: 1, overflowY: 'auto' }} >
                    {step == 1 || ((type == 'Employee' && !selectedEmployee?.value) || (type == 'Guest' && (!guest?.gender || !guest?.tierPolicy?.value))) ? <NoPersonSelected /> : beds.data.length ?
                        beds.data.map(bed => <Bed key={bed.id} bed={bed} />) : <NoAvailableBebds />}
                </ContainerContent>
            </Container>
        </Flex>
        {modal.open && <ConfirmCheckInModal closeModal={closeModal} value={modal.value} />}
    </>
}

const genderOptions = [{ value: 1, label: 'Male' }, { value: 2, label: 'Female' }, { value: 3, label: 'Both' }]

export const tierOptions = [{ value: 1, label: 'VIP' }, { value: 2, label: 'Senior' }, { value: 3, label: 'Junior' }, { value: 4, label: 'Contractor' }]

interface ISelectedEmployee {
    label: string,
    value: number | null,
    role: string,
    gender: string,
    id: number | null,
    checkIn: Date | null,
    checkOut: Date | null,
    tierPolicy: ISelectValue,
    profileImageUrl: string
}

interface IGuest {
    id?: number
    firstName: string,
    lastName: string,
    gender: ISelectValue,
    tierPolicy: ISelectValue,
    checkIn: Date | null,
    checkOut: Date | null,
    identificationNumber: string | null
}